<template>
<div id="siteframe">
	<!-- content -->
	<div id="content">
		<div id="_page_content"><div class="column_100">
	<div id="main" min_height="400" style="; width: 100%"><div>
	<div class="heroband" style="background: #1e2338 url(/static/images/hero-contact.png) center center no-repeat; background-size: cover;">
<h1>Contact Us</h1>
</div></div>



<div id="form_body_117365" style="position: relative; margin: 0 auto; width: 600px; max-width: 90%; padding: 20px; background-color: #fff; border-radius: 10px; border: 0px solid #ccc; box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.25); margin-bottom: 20px; top: -30px;">
	<h1></h1>
			<p></p><p>Please use the form below to contact us with questions or to schedule a demo.</p><p></p>
		<form id="form_117365" name="form_117365" style="margin: 5px 0px 0px 0px; padding: 0px;" method="post">
		<dl class="cf-form" style="width: 100%;">
			<dt class="above">First Name</dt><dd class="above"><input type="input" name="form_117365_field_0" id="form_117365_field_0" value=""></dd><dt class="above">Last Name</dt><dd class="above"><input type="input" name="form_117365_field_1" id="form_117365_field_1" value=""></dd><dt class="above">Email</dt><dd class="above"><input type="input" name="form_117365_field_2" id="form_117365_field_2" value=""></dd><dt class="above">Phone</dt><dd class="above"><input type="input" name="form_117365_field_3" id="form_117365_field_3" value=""></dd><dt class="above">How can we assist you?</dt><dd class="above"><textarea type="input" name="form_117365_field_4" id="form_117365_field_4"></textarea></dd>		</dl>
		<div style="padding-top:10px; position: relative;">
			<!-- <div id="spinner_117365" class="ajax_spinner"><img src="/static/images/spinner.gif"></div> -->
						<!--
			// Check if we re running the application on facebook page
			// and create a input hidden with the value of the signed_request var
			// For sent it to the POST request when user fill the form and submit the data
			-->
			<input type="hidden" name="signed_request" id="signed_request" value="">
			<input type="hidden" name="pardot_url" id="pardot_url" value="">
							<button class="button" onclick="sendForm(117365, '/wdt/crm/ajax/customform.php'); return false;"><div>Submit</div></button>
					</div>
	</form>
</div>


	<div class="container">
		<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d639.722739686038!2d-111.66252932174125!3d40.296819122022164!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1569434514267!5m2!1sen!2sus" width="600" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
	</div>
	

<div>
	<div class="container center">
<h3>Infinitt North America</h3>
<p>755 Memorial Pkwy Suite 304<br> Phillipsburg, NJ 08865</p>
<h3>IBA - Infinitt Business Analytics</h3>
<p>IBA Specialists<br><a href="tel:877-387-6960">877-387-6960</a><br><a href="mailto:info@infinittna.com">info@infinittna.com</a></p>
</div></div>


</div></div>
<div style="clear: both;"></div>
</div>		<div style="clear: both;"></div>
	</div>
	<!-- end content -->	
</div>
</template>

<script>
    import {EventBus} from '../event-bus.js'

    export default {
        name: 'contact',
        data () {
            return {
               
            }
        },
        mounted(){

            
        },
        methods:{
            showNoty: function(){
                EventBus.$emit('noty', {type:'success',msg:'hurray!'});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/js/components/Contact.vue